import styled from 'styled-components';

const StyledCheckBoxWrapper = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #494949;
`;

export default StyledCheckBoxWrapper;
